import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getSalesPriceList } from '@/service/sale/salePrice';
export default function useAggregateList() {
  var aggregateList = ref([]);
  // 获取主机汇总数据
  var getSalesPriceListAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSalesPriceList();
          case 2:
            data = _context.sent;
            aggregateList.value = data.list;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getSalesPriceListAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [aggregateList, getSalesPriceListAsync];
}